import { sessionStorageKeyAuthorizationToken } from '../const/commonConst';
import { getSessionStorage } from '../utils/sessionStorageHandler';
import { mutationDeleteSessionInfo } from '../api/mutationDeleteSessionInfo';

/**
 * セッション情報を削除する関数
 */
export const deleteSessionInfoHandler = async () => {
	// 認証トークンを取得する
	const authorizationToken = getSessionStorage(sessionStorageKeyAuthorizationToken);

	try {
		// セッション情報を削除する
		await mutationDeleteSessionInfo(authorizationToken);

		return;
	} catch (err: unknown) {
		console.error(err);

		return;
	}
};
